import { Injectable, OnDestroy, signal } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable()
export class WebSocketService implements OnDestroy {
  public _connection: HubConnection;
  public readonly _id = signal<string>(undefined);
  public readonly _config = {
    name: 'WebSocket',
    stopOnDestroy: true,
  };

  public get connected() {
    return this._connection?.connectionId;
  }

  constructor() {}

  async startCon() {
    this._connection = new HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/progress`, { withCredentials: false })
      .build();

    try {
      await this._connection.start();
      this._id.set(this._connection.connectionId);
      console.log(`${this._config.name}: `, 'SignalR Connected.');
      return this._id();
    } catch (_) {
      console.error(_);
    }
  }
  async stopCon() {
    try {
      await this._connection?.stop();
      this._id.set(undefined);
      console.log(`${this._config.name}: `, 'SignalR Disconnected.');
    } catch (_) {
      console.error(_);
    }
  }

  ngOnDestroy() {
    if (this._config.stopOnDestroy) this.stopCon();
  }

  registerHandler(handler: string, callback: (data: any) => void) {
    this._connection?.off(handler);
    this._connection?.on(handler, callback);
  }

  onClosed(callback: (error?: Error) => void) {
    this._connection?.onclose(callback);
  }

  invokeHandler(handler: string, sendObj: any, callback: (data: any) => void, catchCallback = console.error) {
    this._connection?.invoke(handler, sendObj).then(callback).catch(catchCallback);
  }
}
